export default {
  cartCache: (state) => {
    return state.cartCache
  },
  paymentType: (state) => {
    return state.paymentType
  },
  getSearchHistory: (state) => {
    return state.searchHistory
  },
  getFilterHistory: (state) => {
    return state.filterHistory
  },
  searchCache: (state) => {
    return state.searchCache
  }
}
